import React, { useContext } from "react";
import hlogo from "./H-logo.jpg";
import { UserContext } from "../../App";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faHandshake, faLifeRing } from '@fortawesome/free-solid-svg-icons';

const HomeSideCards = () => {
  const dataUser = useContext(UserContext);

  const planUpgradePath = ["Silver", "Gold", "Platinum"];

  // Determine the current plan and the next plan for the upgrade message
  const currentPlanIndex = dataUser?.activePlan
    ? planUpgradePath.indexOf(
        dataUser?.activePlan[dataUser?.activePlan.length - 1]?.fields?.category
      )
    : -1;
  const nextPlan =
    currentPlanIndex >= 0 && currentPlanIndex < planUpgradePath.length - 1
      ? planUpgradePath[currentPlanIndex + 1]
      : null;

  return (
    <>

      <div
        style={{
          boxShadow: "0px 1px 5px gray",
          backgroundColor: "royalblue",
          padding: "10px",
          textAlign: "center",
          color: "whitesmoke",
        }}
      >
        <h5>We Interconnect</h5>
        <h6 style={{ color: "whitesmoke" }}>Buyers & Sellers</h6>
        <p style={{ color: "whitesmoke" }}>
          Hola9 Where buyers and suppliers come together for sucessfull business
          varients
        </p>
        <i style={{ color: "whitesmoke" , whiteSpace:'nowrap'}}><FontAwesomeIcon icon={faHandshake} color="#8A2BE2" /> Trusted Platform</i>
        <br />
        <i style={{ color: "whitesmoke" , whiteSpace:'nowrap' }}><FontAwesomeIcon icon={faShieldAlt} color="#1E90FF" /> Safe & Secure</i>
        <br />
        <i style={{ color: "whitesmoke" , whiteSpace:'nowrap' }}><FontAwesomeIcon icon={faLifeRing} color="#FFD700" /> Quick Assistance</i>
      </div>

      {nextPlan ? (
        <div style={{ cursor: "pointer", boxShadow: "0px 0.1px 1px" }}>
          <Link to="/pricing">
            <img
              src={hlogo}
              style={{
                width: "70%",
                margin: "0px 15% 0 15%",
                background: "transparent",
              }}
            />
            {nextPlan && (
              <Link
                to="/pricing"
                style={{
                  color: "whitesmoke",
                  width: "80%",
                  margin: "10px 10% 10px 10%",
                  textAlign: "center",
                  background:
                    "linear-gradient(to right, rgb(17, 17, 85), whitesmoke 200%)",
                  boxShadow: "inherit(0px 1px 3px)",
                }}
              >
                Upgrade your <br />
                plan to <br />
                <button
                  style={{
                    color: "red",
                    width: "80%",
                    margin: "7px 10% 7px 10%",
                    background: "whitesmoke",
                    borderRadius: "3px",
                    padding: "5px",
                  }}
                >
                  {nextPlan}
                </button>
                {/* Display upgrade message only if there's a next plan available */}
              </Link>
            )}
          </Link>
        </div>
      ) : null}

      
      <div></div>
    </>
  );
};

export default HomeSideCards;
